import { styled } from '@mui/material';

export const Page = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '48px',
  width: '100%',
  paddingBottom: '256px',

  [theme.breakpoints.down('lg')]: {
    gap: '40px',
    paddingBottom: '160px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '64px',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '256px',
  width: '100%',

  [theme.breakpoints.down('2xl')]: {
    gap: '192px',
  },
  [theme.breakpoints.down('xl')]: {
    gap: '144px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '112px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '88px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '64px',
  },
}));
